import { Button, Chip, Stack, Typography } from "@mui/material";
import {
  getGrantedScopes,
  getScopeResource,
} from "Components/Sso/ssoResources";
import type { ConnectedAppDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";

const RESOURCES = Resources.Sso.ConnectedApps;

type Props = {
  app: ConnectedAppDto;
  onDisconnect: () => void;
};

export const ConnectedAppRow = ({ app, onDisconnect }: Props) => {
  const { t } = useResource();
  const scopes = getGrantedScopes(app.scopes);

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", sm: "center" }}
      gap={2}
      padding={2}
    >
      <Stack gap={1}>
        <Typography fontWeight="bold">{app.displayName}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t(RESOURCES.ConnectedAt, { date: formatDate(app.connectedAt) })}
        </Typography>
        <Stack direction="row" gap={1} flexWrap="wrap">
          {scopes.map((scope) => {
            const resource = getScopeResource(scope);

            return (
              <Chip
                key={scope}
                size="small"
                label={resource ? t(resource) : scope}
              />
            );
          })}
        </Stack>
      </Stack>
      <Button variant="outlined" color="error" onClick={onDisconnect}>
        {t(RESOURCES.Disconnect)}
      </Button>
    </Stack>
  );
};
